import PropTypes from 'prop-types'
import outerSpinner from '../assets/icons/loading-spinner-outer.svg'
import innerSpinner from '../assets/icons/loading-spinner-inner.svg'

export default function LoadingModal({ isOpen }) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white m-4 rounded-lg p-6 w-[480px] h-[260px] flex flex-col items-center justify-center">
        <div className="relative">
          <img 
            src={outerSpinner} 
            alt="Outer spinner" 
            className="w-100 h-100 animate-spin"
          />
          <img 
            src={innerSpinner} 
            alt="Inner spinner" 
            className="absolute inset-0 w-100 h-100 animate-spin-reverse"
          />
        </div>
      </div>
    </div>
  )
}

LoadingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
} 